import React from 'react';
import { Link } from 'react-router-dom';
import { experienceEntries, getEntryDate, getEntryTitle, getEntryLocation, getEntryDescription } from '../../data/experience';
import { useLocale } from '../../context/LocaleContext';
import './ExperienceWidget.css';

const ExperienceWidget: React.FC = () => {
  const { t, locale, pathFor } = useLocale();
  const latest = experienceEntries[0];
  if (!latest) return null;

  return (
    <div className="experience-section">
      <div className="experience-section-header">
        <h2 className="experience-section-title">{t('home.experience.title')}</h2>
        <Link to={pathFor('resume')} className="experience-view-all">
          {t('home.experience.viewAll')}
        </Link>
      </div>
      <div className="section-content">
        <div className="experience-list" role="region" aria-label="Experience">
          <div className="experience-item">
            <div className="experience-header">
              <div className="experience-date">{getEntryDate(latest, locale)}</div>
              <div className="experience-content">
                <h3 className="experience-title">
                  {getEntryTitle(latest, locale)} ·{' '}
                  <a
                    href={latest.companyUrl}
                    className="experience-company"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {latest.company}
                  </a>
                </h3>
                <p className="experience-location">{getEntryLocation(latest, locale)}</p>
                <p className="experience-description">{getEntryDescription(latest, locale)}</p>
                <ul className="experience-skills">
                  {latest.skills.map((skill) => (
                    <li key={skill}>{skill}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExperienceWidget;
